import {
    ChannelMessageEvent,
    ChannelMessageEventContent_Image,
    ChannelMessageEventContent_Text,
    ChannelMessageEventContentOneOf,
    MessageType,
    RiverTimelineEvent,
    TimelineEvent,
    TimelineEvent_OneOf,
} from '@towns-protocol/sdk'

export type TimelineEventWithContent<T extends TimelineEvent_OneOf> = Omit<
    TimelineEvent,
    'content'
> & {
    content: T
}

export type ChannelMessageEventWithContent<T extends ChannelMessageEventContentOneOf> = Omit<
    ChannelMessageEvent,
    'content'
> & {
    content: T
}

export const isTimelineEventWithChannelMessageContent = (
    event: TimelineEvent | undefined,
): event is TimelineEventWithContent<
    ChannelMessageEventWithContent<
        ChannelMessageEventContent_Text | ChannelMessageEventContent_Image
    >
> => {
    return (
        event?.content?.kind === RiverTimelineEvent.ChannelMessage &&
        isChannelMessageEventWithTextOrImageContent(event?.content)
    )
}

export const isChannelMessageEventWithTextOrImageContent = (
    event: ChannelMessageEvent | undefined,
): event is ChannelMessageEventWithContent<
    ChannelMessageEventContent_Text | ChannelMessageEventContent_Image
> => {
    return (
        event?.content.msgType === MessageType.Text || event?.content.msgType === MessageType.Image
    )
}
